import request from '@/utils/request'
import qs from 'qs'

//关于我们
export function getByFirm(data) {
    return request({
        url: '/xchk/firm/getByFirm',
        method: 'post',
        data
    })
}
//联系我们
export function webGetContactUs(data) {
    return request({
        url: '/xchk/contactUs/webGetContactUs',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/companyProfile.js